import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import Image from '@/app/common/components/Image/Image'
import { currencyFormatter } from '@/app/common/utilities'
import { PaymentItemInfo } from '@/schemas/payments.schema'
import { useTranslation } from 'react-i18next'

interface Props {
  payment_items: PaymentItemInfo[]
}

export const PaymentItemsList = ({ payment_items }: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <Card>
        <CardHeader>
          <h2 className="text-lg font-bold">{t('payment_details.products')}</h2>
        </CardHeader>
        <CardContent>
          <div className="[&>*:nth-child(odd)]:bg-gray-50 space-y-2">
            {payment_items.map((item) => {
              const itemName = item.provider_item.name
              const itemImage = item.provider_item.image

              return (
                <div key={item.id}>
                  <div className="flex items-center gap-2">
                    <div className="h-14 w-14 flex-shrink-0 relative">
                      <div className="absolute h-5 w-5 bg-gray-100 flex items-center justify-center -top-1 -right-1 z-50 border border-gray-300 rounded-full">
                        {item.quantity}
                      </div>
                      {itemImage && (
                        <Image
                          className="h-14 w-14 flex-shrink-0 rounded-md object-cover"
                          path={itemImage}
                        />
                      )}
                    </div>
                    <div>
                      <div className="font-normal text-sm">{itemName}</div>
                      <div className="font-normal">
                        <span className="font-bold">
                          {currencyFormatter.format(item.price)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </CardContent>
      </Card>
    </>
  )
}
